// extracted by mini-css-extract-plugin
export var searchHeader = "_9g-0";
export var searchHeaderDark = "_9g-1";